import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'

class NoMatch extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }
  }

  render() {
    return <Redirect to={{
      pathname: '/'
    }}/>
  }

}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/js/components/NoMatch.jsx